/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_References_Knowledge_None_HintInputs */



/**
* | output |
* | --- |
* | "No knowledge area here." |
*
* @param {Project_References_Knowledge_None_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_knowledge_none_hint = /** @type {((inputs?: Project_References_Knowledge_None_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_Knowledge_None_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hier gibt es keinen Wissensbereich.")
	return /** @type {LocalizedString} */ ("No knowledge area here.")
});